<template>
    <v-layout wrap>

        <v-flex xs12 text-center v-if="facebookLogin !== false" >
            <kimsa-facebook-button
                    retrieve-user-only
                    :disabled="loading || isDisabled"
                    text="Ingresa con Facebook"
                    v-on:success="facebookSuccess"
                    v-on:error="facebookError"
            ></kimsa-facebook-button>
        </v-flex>

        <v-flex xs12 text-center >
          <h3 class="font-weight-light"><span v-if="facebookLogin !== false" >ó</span> Ingresa tus datos:</h3>
        </v-flex>


        <v-flex xs12>
            <user-form
                    ref="userForm"
                    :disabled="isDisabled"
                    :loading="loading"
                    :submit-fn="save"
                    :submit-label="submitLabel"
                    v-on:validation-change="validationChange"
                    simple
            >

                <template v-slot:others>
                    <slot name="append"></slot>
                    <terms-and-conditions-advice></terms-and-conditions-advice>
                </template>

            </user-form>

        </v-flex>

    </v-layout>

</template>

<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    import UserForm from './UserForm.vue'
    import TermsAndConditionsAdvice from './TermsAndConditionsAdvice.vue'

    import KimsaFacebookButton from '@/components/common/KimsaFacebookButton'

    export default{
        props: ['autoLogin', 'accountType', 'submitLabel', 'disabled', 'facebookLogin'],
        components: {
            KimsaFacebookButton,
            UserForm,
            TermsAndConditionsAdvice
        },
        data(){
            return {
                valid: false,
                firstName: '',
                lastNames: '',
                email: '',
                password: '',
                passwordConfirmation: '',
                acceptTerms: false,
                role: this.accountType || 'c',
                loading: false,
                showPassword: false,
                emailRules: [
                    v => /.+@.+/.test(v) || 'E-mail inválido'
                ],
                passwordRules: [
                    v => !!v || 'Contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ],
                passwordConfirmationRules: [
                    v => !!v || 'Confirmación de contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres',
                    v => v == this.password || 'Las contraseñas no coinciden'
                ],
                firstNameRules: [
                    v => !!v || 'Nombre es obligatorio',
                    v => v.length >= 2 || 'Debe tener al menos 2 caracteres'
                ],
                lastNameRules: [
                    v => !!v || 'Apellido obligatorio',
                    v => v.length >= 2 || 'Debe tener al menos 2 caracteres'
                ]
            }
        },
        computed:{
            isDisabled(){
                return this.disabled != undefined && this.disabled !== false
            },
            isAutoLogin(){
                return this.autoLogin != undefined && this.autoLogin !== false
            }
        },
        mounted(){

        },
        watch:{
            valid(val){
                this.$emit('validation-change', val)
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            clear(){
                if(!this.$refs.userForm) return
              this.$refs.userForm.setUserDefaults()
            },
            triggerOnFail(err){
                var vm = this
                if(err.result && err.result.email){
                    err.message = err.result.email[0]
                }
                vm.loading = false
                vm.$emit('error', err)
            },
            async facebookSuccess(authResponse){
                var vm = this
                vm.$emit('before-send')
                vm.loading = true
                var userResponse = await ApiUtils.makePost('auth/social/facebook/user', { accessToken: authResponse.accessToken })
                const json = await userResponse.json()

                if(!vm.isAutoLogin){
                    vm.$emit('success', json.result.user)
                    vm.loading = false
                    vm.clear()
                    return
                }

                const loginResponse = await ApiUtils.loginWithSocial(authResponse.accessToken)
                if(loginResponse.code != 200){
                    const json = await loginResponse.json()
                    vm.$emit('error', json)
                    vm.loading = false
                    return
                }

                vm.$emit('success', json.result.user)
                vm.clear()
                vm.loading = false
            },
            facebookError(response){
                var vm = this
                vm.loading = false
                console.error('error trying to login with facebook', response)
            },
            validationChange(valid){
              this.valid = valid
            },
            async save(user){

                var vm = this

                if(!vm.valid){
                    vm.showSnackBar('Datos de registro inválidos')
                    return
                }

                vm.$emit('before-send')
                vm.loading = true

                const response = await ApiUtils.makePost('signup/specialist', {
                    email: user.email,
                    first_name: user.first_name,
                    // last_names: user.last_names,
                    last_name: user.last_name,
                    mother_last_name: user.mother_last_name,
                    password: user.password,
                    password_confirmation: user.password,
                })

                if(!response.ok){
                    console.log('sign up failed')
                    const json = await response.json()
                    var emailError = json.result.email ? json.result.email[0] : null

                    if(emailError) {
                        vm.showSnackBar(emailError)
                    }

                    vm.triggerOnFail(json)
                    return
                }

                if(!vm.isAutoLogin){
                    console.log('not autologin, moving on...')
                    const json = await response.json()
                    vm.$emit('success', json.result.user)
                    vm.loading = false
                    return
                }

                console.log('calling (auto)login from AccountSignupForm')
                const loginResponse = await ApiUtils.login(user.email, user.password, true)
                if(loginResponse.code != 200){
                    console.log('autologin failed...')
                    const json = await loginResponse.json()
                    vm.triggerOnFail(json)
                    return
                }

                const json = await response.json()
                console.log('autologin success:', json)
                vm.$emit('success', json.result.user)
                vm.clear()
                vm.loading = false

            }
        }
    }
</script>

